

















































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment-mini";
import FamilySection from "./template/family/index.vue"; // 财富体检
import InvestSection from "./template/invest/index.vue"; // 投资规划
import BaseSection from "./template/base/index.vue"; // 保障规划
// import PensionSection from './template/pension/index.vue' // 退休规划
import newPensionSection from "@/views/print/template/newPension/index.vue"; // 新版退休规划
import ChildSection from "./template/child/index.vue"; // 教育规划
import compliance from "./template/compliance/index.vue"; // 合规尾页
import { UserModule } from "@/store/modules/user";
import { PersionModule } from "@/store/modules/pension";
import { Print } from "@/views/print/pdf/index";
import loadCoverImage from "./template/loadCoverImage/index.vue";
import { CommonMudule } from "@/store/modules/common";

@Component({
  name: "print",
  components: {
    loadCoverImage,
    FamilySection,
    InvestSection,
    BaseSection,
    newPensionSection,
    ChildSection,
    compliance,
  },
})
export default class extends Vue {
  showDialog = true;
  onlyChild = false;
  userObj = UserModule.userInfo;
  listData = {
    family: false,
    invest: false,
    base: false,
    pension: false,
    child: false,
  };

  times = 8;
  timer = null;
  isLoading = true;
  keyList: string[] = [];
  get time() {
    return moment().format("YYYY-MM-DD");
  }
  get picListObj() {
    const aa = CommonMudule.imgSource;
    console.log(aa);
    return aa;
  }


  created() {
    PersionModule.SET_TABLESHOW(true);
  }


  beforeDestroy() {
    PersionModule.SET_TABLESHOW(false);
  }

  showView(type: string) {
    // if (UserModule.authConfig.includes(type)) {
    //   return true;
    // }
    // return false;
    return true
  }

  closeDialog() {
    this.showDialog = false;
  }

  showDialogEvent() {
    this.showDialog = true;
  }

  downPDF() {
    this.showDialog = false;
    this.$nextTick(() => {
      this.pageDFS();
      // setTimeout(() => {
      //   this.showDialog = true;
      //   window.print();
      // }, 600);
    });
  }

  // mark
  pageDFS() {
    let printMap = new Map([
      ["family", {moduleId:  "#print-analy-wraper", moduleInfo: {title: '财富体检'}}],
      ["pension",   {moduleId:  "#print-pension-wraper", moduleInfo: {title: '财富体检'}}],
      ["base",  {moduleId:  "#print-base-wraper", moduleInfo: {title: '财富体检'}} ],
      ["child",   {moduleId:  "#print-child-wraper", moduleInfo: {title: '财富体检'}}  ],
      ["invest",   {moduleId:  "#print-invest-wraper", moduleInfo: {title: '财富体检'}}  ],
      ["compliance",   {moduleId:  "#print-compliance-wraper", moduleInfo: {title: '财富体检'}}],

    ]);
    new Print(this.keyList, printMap);
  }


  mounted() {

    document.title = "建议书";
    const keys = this.$route.query.keys || "";
    let keyList = (keys as string).split(",");
    this.keyList = [...keyList, "compliance"];
    console.log("keyList", keyList);

    if (keyList.length === 2 || keyList.length === 3) {
      this.times = 10;
    }
    if (keys === "child") {
      this.onlyChild = true;
    }
    if (keyList.length === 4 || keyList.length === 5) {
      this.times = 15;
    }
    if (keys) {
      keyList.forEach((item: string) => {
        this.$set(this.listData, item, true);
      });
    }
    (this as any).timer = setInterval(() => {
      this.times--;
      if (this.times === 0) {
        clearInterval((this as any).timer);
      }
    }, 1000);
  }
}
